

import { Spinner } from "react-bootstrap"

export default function LoadingSpinner(props) {
    // spinner to show loading state, placed in middle of page over other components
    // props
    //      button === true: set as span so that can be used inside button text
    //      variant: bootstrap variant strings, default "secondary"
return (
    <Spinner
    as={props.button?"span":"div"}
    animation="border"
    size={props.button?"sm":"lg"}
    role="status"
    aria-hidden="true"
    variant={props.variant || "secondary"}
    className={props.button?"":"spinner"}
    style={{zIndex: "100"}}
  />
)
}